import React from 'react';
import PropTypes from 'prop-types';
import RateGridAccorindon from './rateGridAccorindon';
import GroupRate from './groupRateAccorindon';

/**
 * Component to manage Rates And Rates in Groud
 * @param {object} event: event object to have id event
 * @param {object} ratesAndGroups: object with rates and groups
 * @param {object} discountForm: discountForm object form discount
 * @param {func} onDiscounts: onDiscounts fun to set form
 */
export default function RateGrid({ event, ratesAndGroups, discountForm, onDiscounts, openAllAccorindon }) {
    const { rates, groups } = ratesAndGroups;

    const handleDiscountChange = (rate, rateId, value) => {
        let tmpRates = { ...discountForm.rate };
        tmpRates[rateId] = {
            rate_id: rateId,
            value
        };

        if (rate.fees?.length) {
            tmpRates[rateId]['fees'] = rate.fees.map(fee => fee.id);
        }
        onDiscounts('rate', tmpRates);
    };

    return (
        <>
            {rates.map((rate, index) => (
                <RateGridAccorindon
                    event={event}
                    rate={rate}
                    key={`${openAllAccorindon}-${rate.id}`}
                    openByDefault={openAllAccorindon || index === 0}
                    handleDiscountChange={handleDiscountChange}
                    discountForm={discountForm}
                />
            ))}

            {groups.map((group, index) => {
                return (
                    <GroupRate
                        openByDefault={openAllAccorindon || (!rates.length && index === 0)}
                        key={`${openAllAccorindon}-${group.id}`}
                        group={group}
                        rates={rates}
                        event={event}
                        handleDiscountChange={handleDiscountChange}
                        discountForm={discountForm}
                        openAllAccorindon={openAllAccorindon}
                    />
                );
            })}
        </>
    );
}

RateGrid.propTypes = {
    event: PropTypes.object.isRequired,
    ratesAndGroups: PropTypes.object.isRequired,
    discountForm: PropTypes.object.isRequired,
    onDiscounts: PropTypes.func.isRequired,
    openAllAccorindon: PropTypes.bool
};
